<template>
    <div class="popup request-popup">
        <div :class="`popup-inner step-${step}`">
            <div class="popup-header">
                <h1>{{ title }}</h1>
                <img @click="close()" src="../../../../images/close.png" alt>
            </div>
            <div v-if="step === 1" class="popup-body scroll-grey step-one">
                <div class="form-field">
                    <div class="field-label">{{ $t('request_type') }}</div>
                    <el-select
                        remote
                        filterable
                        v-model="type"
                        placeholder=""
                        reserve-keyword
                    >
                        <el-option value="absence" :label="$t('absence')"/>
                        <el-option value="sick" :label="$t('sick')"/>
                        <el-option value="vacation" :label="$t('vacation')"/>
                        <el-option value="time_for_time" :label="$t('time_for_time')"/>
                    </el-select>
                </div>
            </div>
            <div v-else class="popup-body scroll-grey step-two">
                <div v-if="type === 'sick'" class="single-area">
                    <div class="fields-group">
                        <div :class="`form-field ${instance.errors.day ? 'field-invalid' : ''}`">
                            <div class="field-label">{{ $t('date') }}</div>
                            <el-date-picker
                                type="date"
                                placeholder=""
                                format="dd-MM-yyyy"
                                v-model="instance.day"
                                value-format="yyyy-MM-dd"
                            />
                        </div>
                        <div :class="`form-field ${instance.errors.time ? 'field-invalid' : ''}`">
                            <div class="field-label">{{ $t('free_day_hours') }}</div>
                            <el-time-select
                                v-model="instance.time"
                                :picker-options="{
                                    start: '00:00',
                                    step: '00:15',
                                    end: $Company().distance
                                }"
                                :clearable="false"
                                placeholder="--:--"
                            />
                        </div>
                    </div>
                    <div class="fields-group">
                        <div class="form-field">
                            <div class="field-label">{{ $t('notes') }}</div>
                            <el-input type="textarea" :rows="5" v-model="instance.notes"></el-input>
                        </div>
                    </div>
                </div>
                <div v-else class="multiple-area">
                    <div class="request-dates">
                        <div class="form-field">
                            <div class="field-label">{{ $t('select_the_date_range') }}</div>
                            <el-date-picker
                                v-model="range"
                                type="daterange"
                                @change="change()"
                                format="dd-MM-yyyy"
                                :range-separator="$t('to')"
                                :end-placeholder="$t('end_date')"
                                :start-placeholder="$t('start_date')"
                            />
                        </div>
                    </div>
                    <div v-if="instance.length" class="request-content">
                        <div class="placeholder-area">
                            <span>{{ $t('free_day_hours') }}</span>
                        </div>
                        <div class="requested-days">
                            <div class="requested-day" v-for="(item, key) in instance" :key="`requested-day-${key}`">
                                <div class="form-field">
                                    <span>{{ moment(item.day, 'YYYY-MM-DD').format('dddd') }}</span>
                                    <span>{{ moment(item.day, 'YYYY-MM-DD').format('D MMMM') }}</span>
                                </div>
                                <div :class="`form-field ${item.errors.time ? 'field-invalid' : ''}`">
                                    <el-time-select
                                        v-model="item.time"
                                        :picker-options="{
                                            start: '00:00',
                                            step: '00:15',
                                            end: $Company().distance
                                        }"
                                        :clearable="false"
                                        placeholder="--:--"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="requested-days-total">
                            <span>{{ $t('total_hours') }}</span>
                            <span>{{ total }}</span>
                        </div>
                        <div class="request-summary">
                            <div class="summary-description">{{ $t('summary') }}</div>
                            <div class="summary-items">
                                <span>{{ $t('request_type') }}: {{ $t(type) }}</span>
                                <span>{{ $t('requested_hours') }}: {{ total }}</span>
                                <span v-if="!is_director && type !== 'time_for_time'">
                                    {{ $t('used_hours') }}: {{ label.used_hours() }}
                                </span>
                                <span v-if="!is_director && type !== 'time_for_time'">
                                    {{ label.available_vacation() }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!is_director && type !== 'time_for_time'" class="vacation-container">
                    <p class="vacation-placeholder">{{ $t('sick_labels.checkbox') }}</p>
                    <div class="vacation-section">
                        <p class="vacation-year">
                            {{ $t('available_hours_in_year', {year: moment().format('Y')}) }}
                        </p>
                        <div class="vacation-item" v-for="(field, key) in fields.current" :key="`current-${key}`">
                            <div class="vacation-label">{{ label.vacation(field) }}</div>
                            <div :class="`form-field ${selection[field].error ? 'field-invalid' : ''}`">
                                <el-time-select
                                    v-model="selection[field].time"
                                    :picker-options="{
                                        start: '00:00',
                                        step: '00:15',
                                        end: '100:00'
                                    }"
                                    :clearable="false"
                                    placeholder="--:--"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="vacation-section">
                        <p class="vacation-year">
                            {{ $t('available_hours_in_year', {year: moment().subtract(1, 'years').format('Y')}) }}
                        </p>
                        <div class="vacation-item" v-for="(field, key) in fields.previous" :key="`previous-${key}`">
                            <div class="vacation-label">{{ label.vacation(field) }}</div>
                            <div :class="`form-field ${selection[field].error ? 'field-invalid' : ''}`">
                                <el-time-select
                                    v-model="selection[field].time"
                                    :picker-options="{
                                        start: '00:00',
                                        step: '00:15',
                                        end: '100:00'
                                    }"
                                    :clearable="false"
                                    placeholder="--:--"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="step === 1" class="popup-footer">
                <el-button round size="medium" type="primary" @click="next()">{{ label.next() }}</el-button>
            </div>
            <div v-else class="popup-footer">
                <span @click="back()">{{ $t('back_to_request_type') }}</span>
                <el-popconfirm
                    icon-color="red"
                    icon="el-icon-info"
                    @confirm="submit()"
                    :cancel-button-text="$t('no')"
                    :confirm-button-text="$t('yes')"
                    :title="$t('request_free_day_question', {type: $t(type).toLowerCase(), hours: total})"
                >
                    <el-button slot="reference" size="medium" type="primary" round>{{ label.submit() }}</el-button>
                </el-popconfirm>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import {Message} from "element-ui";
import {$http} from "../../../../hooks/api";
import helper from "../../../../mixins/helper";
import {roles} from "../../../../constants/roles";
import {base_url} from "../../../../constants/api";

export default {
    mixins: [helper],
    data() {
        return {
            moment,
            step: 1,
            type: 'absence',
            range: [],
            instance: null,
            selection: null
        };
    },
    methods: {
        back() {
            this.step = 1;
            this.range = [];
            this.instance = null;
            this.selection = null;
        },
        next() {
            this.step = 2;

            if (this.type === 'sick') {
                this.instance = {
                    day: null,
                    time: '00:00',
                    notes: null,
                    errors: {}
                };
            } else {
                this.instance = [];
            }

            this.selection = this.vacations.reduce((acc, prefix) => ({
                ...acc,
                [`${prefix}_hours`]: {time: '00:00', error: false},
                [`remaining_${prefix}_hours`]: {time: '00:00', error: false}
            }), {});
        },
        close() {
            this.$parent.toggleRequest();
        },
        change() {
            const range = this.range || [];

            if (range.length === 2) {
                const [from, to] = range;
                const start = moment(from);
                const end = moment(to);
                const days = moment(end).diff(start, 'days') + 1;

                this.instance = [];

                let available = Object.values(this.$User()['available_leave_hours']).reduce((acc, value) => acc + value, 0);

                for (let i = 0; i < days; i++) {
                    const use = available >= 8 ? 8 : available;
                    const hours = Math.floor(use);
                    const minutes = Math.round((use - hours) * 60);

                    available -= use;

                    this.instance.push({
                        day: moment(start).add(i, 'days').format('YYYY-MM-DD'),
                        time: `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`,
                        errors: {}
                    });
                }
            } else {
                this.instance = [];
            }

            this.selection = this.vacations.reduce((acc, prefix) => ({
                ...acc,
                [`${prefix}_hours`]: {time: '00:00', error: false},
                [`remaining_${prefix}_hours`]: {time: '00:00', error: false}
            }), {});
        },
        submit() {
            const payload = {
                type: this.type,
                instance: this.instance,
                selection: this.selection
            };

            this.$store.commit('setPreloader', true);

            $http().post(`${base_url}/api/client/free-day`, payload).then(async ({data}) => {
                if (data.success) {
                    this.$parent.getFreeDays();

                    await $http().post(`${base_url}/api/me`).then(({data}) => this.$store.commit('setUser', data.user));

                    this.close();

                    Message({
                        message: data.message,
                        showClose: true,
                        type: 'success'
                    });
                } else {
                    this.instance = data.instance;
                    this.selection = data.selection;

                    if (data.message) {
                        Message({
                            message: data.message,
                            showClose: true,
                            type: 'warning'
                        });
                    }
                }

                this.$store.commit('setPreloader', false);
            }).catch(() => {
                this.$store.commit('setPreloader', false);
            });
        }
    },
    computed: {
        title: function () {
            if (this.step === 1) {
                return this.$t('new_request');
            }
            return this.type === 'sick' ? this.$t('sick_labels.reporting') : this.$t('new_request');
        },
        label: function () {
            return {
                next: () => {
                    if (this.type === 'sick') {
                        return this.$t('sick_labels.call_in_now');
                    }
                    return this.$t('select_the_days');
                },
                submit: () => {
                    if (this.type === 'sick') {
                        return this.$t('sick_labels.send_reporting');
                    }
                    return this.$t('send_request');
                },
                vacation: field => {
                    return `${this.$t(field.replace('remaining_', ''))} (${this.$User()['available_leave_hours'][field].toFixed(2)})`;
                },
                used_hours: () => {
                    return Object.values(this.selection).reduce((acc, {time}) => {
                        const [hours, minutes] = time.split(':').map(Number);

                        return acc + (hours + minutes / 60);
                    }, 0).toFixed(2);
                },
                available_vacation: () => {
                    const hours = Object.values(this.$User()['available_leave_hours']).reduce((acc, value) => acc + value, 0);

                    const days = Math.floor((hours / 8) * 10) / 10;

                    return this.$t('available_vacation', {days, hours});
                }
            };
        },
        total: function () {
            if (this.type === 'sick') {
                return this.$TimesToHours(this.instance.time);
            }
            return this.$TimesToHours(this.instance.map(({time}) => time));
        },
        fields: function () {
            return {
                current: Object.keys(this.selection).filter(x => !x.includes('remaining')),
                previous: Object.keys(this.selection).filter(x => x.includes('remaining'))
            };
        },
        vacations: function () {
            return ['free', 'extra', 'overtime'];
        },
        is_director: function () {
            return this.$RoleIs(roles.director);
        }
    }
}
</script>